import { Box } from "@mui/material";
import Footer from "components/layout/Footer";
import ExplorePage from "features/Explore";
import React from "react";
import { Helmet } from "react-helmet-async";
import { fillParent, scrollingBox, footerFlex } from "utils/base-styles";

export default function PublicIndexPage() {
  return (
    <Box
      sx={{
        ...fillParent,
        ...scrollingBox,
      }}
    >
      <Helmet>
        <title>Sooth - Public Collections</title>
      </Helmet>
      <ExplorePage />
      <Footer sx={{px: 0}} />
    </Box>
  );
}
